<div class="information-block">
  <i class="ri-information-fill"></i>
  <span><ng-content></ng-content>{{ text }}</span>
</div>
